import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: (t) => MenuEntry[] = (t) =>[
  {
    label:t(313,'Trade'),
    icon: 'TradeIcon',
    initialOpenState: true,
    items: [
      {
        label: t(8,'Swap'),
        href: '/swap'
      },
      {
        label: t(74,'Liquidity'),
        href: '/pool'
      }
    ]
  },
  {
    label:t(314,'Farms'),
    icon: 'FarmIcon',
    initialOpenState: false,
    items: [
      {
      label: `${t(331,'PSC Farms V5')}`,
      href: 'https://pool.polysmartchain.com/'
      }
    ]
  }
  ,
  {
    label: t(333,'Social'),
    icon: 'GroupsIcon',
    href: 'https://social.polysmartchain.com/',
  },
  {
    label: t(334,'PolyJetClub'),
    icon: 'NftIcon',
    initialOpenState: false,
    items: [
      {
        label: t(334,'PolyJetClub'),
        href: 'https://polyjetclub.polysmartchain.com/'
      },
      {
        label: t(338,'PolyPotion'),
        href: 'https://polypotion.polysmartchain.com/'
      }
    ]
  },
  {
    label: t(335,'PolyDao'),
    icon: 'TicketIcon',
    initialOpenState: false,
    items: [
      {
        label: t(335,'PolyDao'),
        href: 'https://polydao.polysmartchain.com/'
      },
      {
        label: t(337,'Proposal'),
        href: 'https://proposal.polysmartchain.com/'
      }
    ]
  }

]

export default config
